import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import "@bytel/logger-core";
import { WebPrismeLogger } from "../WebPrismeLogger.js";
const PrismeContext = createContext(null);
const usePrismeLogger = () => {
  const prismeContext = useContext(PrismeContext);
  if (!prismeContext) {
    throw new Error("usePrisme must be used within a PrismeProvider");
  }
  return prismeContext;
};
const PrismeProviderBase = ({ children, logger }) => {
  return /* @__PURE__ */ jsx(PrismeContext.Provider, { value: { prismeLogger: logger }, children });
};
export {
  PrismeProviderBase,
  WebPrismeLogger,
  usePrismeLogger
};
//# sourceMappingURL=index.js.map
